<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CHECK_PROCESSING_LIST')">
        <slot name="section-check-processing-list">
          <section-check-processing-list ref="CHECK_PROCESSING_LIST"
                                         id="CHECK_PROCESSING_LIST"
                                         :extended="isExtended('CHECK_PROCESSING_LIST')"
                                         :showButton="true"
                                         :autoSave="true"
                                         :readOnly="readOnly"
                                         :moduleId="moduleId"
                                         :searchText="searchText"
                                         :ressourceHeader="ressource"
                                         :fiche="fiche"
                                         :transaction=selectedTransaction
                                         :route="route"
                                         :attribut="attribut"
                                         @extended="setExtended"
                                         @fullscreen="setFullscreen"
                                         @status="updateStatus"
                                         @toggleCardView="toggleCardView"
                                         @updated="transactionUpdated"
                                         @selectItem = "selectItem">
          </section-check-processing-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CHECK_EMITED_LIST')">
        <slot name="section-check-emited-list">
          <section-check-emited-list ref="CHECK_EMITED_LIST"
                                     id="CHECK_EMITED_LIST"
                                     :extended="isExtended('CHECK_EMITED_LIST')"
                                     :showButton="true"
                                     :autoSave="true"
                                     :readOnly="readOnly"
                                     :moduleId="moduleId"
                                     :searchText="searchText"
                                     :ressourceHeader="ressource"
                                     :fiche="fiche"
                                     :transaction=selectedTransaction
                                     :route="route"
                                     :attribut="attribut"
                                     @extended="setExtended"
                                     @fullscreen="setFullscreen"
                                     @status="updateStatus"
                                     @toggleCardView="toggleCardView"
                                     @updated="transactionUpdated"
                                     @selectItem = "selectItem">
          </section-check-emited-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CHECK_PAYED_LIST')">
        <slot name="section-check-payed-list">
          <section-check-payed-list ref="CHECK_PAYED_LIST"
                                    id="CHECK_PAYED_LIST"
                                    :extended="isExtended('CHECK_PAYED_LIST')"
                                    :showButton="true"
                                    :autoSave="true"
                                    :readOnly="readOnly"
                                    :moduleId="moduleId"
                                    :searchText="searchText"
                                    :ressourceHeader="ressource"
                                    :fiche="fiche"
                                    :transaction=selectedTransaction
                                    :route="route"
                                    :attribut="attribut"
                                    @extended="setExtended"
                                    @fullscreen="setFullscreen"
                                    @status="updateStatus"
                                    @toggleCardView="toggleCardView"
                                    @updated="transactionUpdated"
                                    @selectItem = "selectItem">
          </section-check-payed-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Transaction from '@/extend/classes/Transaction';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionCheckProcessingList from '@/extend/sections/SectionCheckProcessingListExtend.vue';
import SectionCheckEmitedList from '@/extend/sections/SectionCheckEmitedListExtend.vue';
import SectionCheckPayedList from '@/extend/sections/SectionCheckPayedListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionCheckProcessingList,
    SectionCheckEmitedList,
    SectionCheckPayedList,
    FicheHeader,
  },

  props: {
    transaction: {
      type: Object as PropType<Transaction>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.CHECKS_EMIS,
      sections: [
        'CHECK_PROCESSING_LIST',
        'CHECK_EMITED_LIST',
        'CHECK_PAYED_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_CHECKS_EMIS);
    },

    selectedTransaction (): Transaction {
      return this.transaction
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    transactionUpdated (transaction: Transaction) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.transaction || this.transaction.id < 0) && value == 'CHECK_PROCESSING_LIST') {
        this.setExtended(new Extended('CHECK_PROCESSING_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
